import { render, staticRenderFns } from "./mon.vue?vue&type=template&id=6c40248e&"
import script from "./mon.vue?vue&type=script&lang=js&"
export * from "./mon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports